import { ca } from '@cian/analytics';

export function trackHover() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'Hover',
    label: 'RelevantPriceIcon',
    useLastProducts: true,
  });
}
